import React, { useEffect, useRef, useState } from 'react'
import ContainerDashboard from '../../components/layouts/ContainerDashboard'
import Loader from '../Loader'
import { axiosInstance } from '../Config'
import { useNavigate } from 'react-router-dom'
import Pagination, { PerPageSelect } from '../../components/Pagination'
import logo from '../../Assets/Images/chat.png'

const avatarColors = ['#A44CD7', '#0CACC2', '#F55145', '#F9BE22', '#8A3BBD']

const getInitials = (name = '') =>
    name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)

const formatDate = (iso) => {
    if (!iso) return '—'
    const d = new Date(iso)
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

const formatTime = (iso) => {
    if (!iso) return ''
    const d = new Date(iso)
    return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
}

const AiChats = () => {
    const navigate = useNavigate()

    const [allUsers, setAllUsers] = useState([])
    const [filteredUsers, setFilteredUsers] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")
    const [selectedUser, setSelectedUser] = useState(null)
    const [page, setPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    useEffect(() => {
        document.title = "AI Chats | Mindora"
        window.scrollTo(0, 0)
        fetchUsers()
    }, [])

    const fetchUsers = () => {
        setLoading(true)
        axiosInstance.get('/admin/kids')
            .then(res => {
                const data = res.data?.data ?? res.data
                const list = Array.isArray(data) ? data : (data?.kids ?? data?.users ?? [])
                setAllUsers(list)
                setFilteredUsers(list)
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false))
    }

    const onSearch = (e) => {
        const query = e.target.value
        setSearchQuery(query)
        setPage(1)
        if (!query.trim()) {
            setFilteredUsers(allUsers)
        } else {
            setFilteredUsers(
                allUsers.filter(u =>
                    (u.username || '').toLowerCase().includes(query.toLowerCase()) ||
                    (u.parent?.email || '').toLowerCase().includes(query.toLowerCase())
                )
            )
        }
    }

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage)
    const pagedUsers = filteredUsers.slice((page - 1) * itemsPerPage, page * itemsPerPage)

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="AI Chats" description="View conversations between kids and AI">
                <section className="ps-dashboards">
                    <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                        <div className="d-md-flex justify-content-between align-items-center mb-4 gap-3">
                            <div className="d-flex align-items-center">
                                <div className="ps-form--search-simple">
                                    <input
                                        className="form-control bg-white"
                                        type="text"
                                        value={searchQuery}
                                        onChange={onSearch}
                                        placeholder="Search by name or parent email..."
                                    />
                                    <button type="button">
                                        <i className="icon icon-magnifier"></i>
                                    </button>
                                </div>
                                <PerPageSelect itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} setPage={setPage} />
                            </div>
                            <div className="d-flex align-items-center gap-3 flex-shrink-0 mt-2 mt-md-0">
                                <button
                                    type="button"
                                    className="button"
                                    style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}
                                    onClick={() => navigate(-1)}
                                >
                                    <i className="icon-arrow-left me-2"></i>
                                    Back
                                </button>
                            </div>
                        </div>

                        <div className='table-responsive'>
                            <table className='jean-table table'>
                                <tbody>
                                    {pagedUsers.map((user, index) => (
                                        <tr key={user.userKey || user.id}>
                                            <td>
                                                <div className="rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: 44, height: 44, background: avatarColors[index % avatarColors.length], color: '#fff', fontWeight: 700, fontSize: 14 }}>
                                                    {getInitials(user.username)}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Name</p>
                                                    <p className='mb-0 fw-semibold' style={{ color: '#1a1a2e' }}>{user.username}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Age</p>
                                                    <p className='mb-0'>{user.age} yrs</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Parent Email</p>
                                                    <p className='mb-0'>{user.parent?.email || '—'}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Total Chats</p>
                                                    <span className="badge rounded-pill px-3 py-1"
                                                        style={{ background: 'rgba(1,156,241,0.12)', color: 'var(--primary)', fontWeight: 600, fontSize: 13 }}>
                                                        {user.activityOverview?.totalChats ?? 0}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p className='mb-1' style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }}>Joined</p>
                                                    <p className='mb-0'>{formatDate(user.joinedDate)}</p>
                                                </div>
                                            </td>
                                            <td className='pe-3'>
                                                <div className='d-flex justify-content-end'>
                                                    <button type="button" className="btn fw-semibold"
                                                        style={{ background: 'linear-gradient(135deg, var(--btn-primary), var(--btn-secondary))', color: '#fff', borderRadius: 8, fontSize: 13, padding: '6px 14px', border: 'none' }}
                                                        onClick={() => setSelectedUser(user)}>
                                                        <i className="bi bi-chat-dots me-1"></i>
                                                        View Chats
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {!loading && filteredUsers.length === 0 && (
                                        <tr><td colSpan={7}><div className="alert alert-success ps-4 m-2">No users found!!</div></td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            page={page} totalPages={totalPages}
                            setPage={setPage} totalItems={filteredUsers.length}
                            showingCount={pagedUsers.length}
                        />
                    </div>
                </section>
            </ContainerDashboard>

            {selectedUser && (
                <ChatModal user={selectedUser} onClose={() => setSelectedUser(null)} />
            )}
        </>
    )
}

const highlightWords = (text, words) => {
    let wordList
    if (Array.isArray(words)) {
        wordList = words
    } else if (typeof words === 'string') {
        try { wordList = JSON.parse(words) } catch { wordList = words.split(',').map(w => w.trim()).filter(Boolean) }
    } else {
        wordList = []
    }
    if (!wordList.length || !text) return text
    const pattern = wordList.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
    const parts = text.split(new RegExp(`(${pattern})`, 'gi'))
    return parts.map((part, i) =>
        wordList.some(w => w.toLowerCase() === part.toLowerCase())
            ? <mark key={i} style={{ background: '#ffe8e6', color: '#d93025', padding: '1px 4px', borderRadius: 3, fontWeight: 700 }}>{part}</mark>
            : part
    )
}

const ChatModal = ({ user, onClose }) => {
    const chatEndRef = useRef(null)
    const [conversations, setConversations] = useState([])
    const [restrictedChats, setRestrictedChats] = useState([])
    const [activeConversation, setActiveConversation] = useState(null)
    const [activeMessages, setActiveMessages] = useState(null)
    const [activeTab, setActiveTab] = useState('chats')
    const [speakingId, setSpeakingId] = useState(null)
    const [showSidebar, setShowSidebar] = useState(true)
    const [loadingChats, setLoadingChats] = useState(true)
    const [loadingMessages, setLoadingMessages] = useState(false)
    const userKey = user.userKey

    useEffect(() => {
        setLoadingChats(true)
        Promise.all([
            axiosInstance.get(`/admin/kids/${userKey}/chats`),
            axiosInstance.get(`/admin/kids/${userKey}/restricted-chats`)
        ]).then(([chatsRes, restrictedRes]) => {
            const chatsData = chatsRes.data?.data ?? chatsRes.data
            const convList = chatsData?.conversations ?? []
            setConversations(convList)

            const restrictedData = restrictedRes.data?.data ?? restrictedRes.data
            setRestrictedChats(restrictedData?.restrictedChats ?? [])

            if (convList.length > 0) {
                fetchMessages(convList[0])
            }
        }).catch(err => console.error(err))
          .finally(() => setLoadingChats(false))
    }, [userKey])

    const fetchMessages = (conv) => {
        setActiveConversation(conv)
        setLoadingMessages(true)
        axiosInstance.get(`/admin/kids/${userKey}/chats/${conv.id}`)
            .then(res => {
                const data = res.data?.data ?? res.data
                setActiveMessages({ id: data.id, title: data.title, messages: data.messages ?? [], createdAt: data.createdAt })
            })
            .catch(err => console.error(err))
            .finally(() => setLoadingMessages(false))
    }

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [activeMessages])

    useEffect(() => {
        window.speechSynthesis.cancel()
        setSpeakingId(null)
    }, [activeMessages])

    const ttsResumeRef = useRef(null)

    useEffect(() => {
        return () => {
            window.speechSynthesis.cancel()
            clearInterval(ttsResumeRef.current)
        }
    }, [])

    const speakMessage = (msg) => {
        if (speakingId === msg.id) {
            window.speechSynthesis.cancel()
            clearInterval(ttsResumeRef.current)
            setSpeakingId(null)
            return
        }
        window.speechSynthesis.cancel()
        clearInterval(ttsResumeRef.current)
        const utterance = new SpeechSynthesisUtterance(msg.content)
        utterance.rate = 0.95
        utterance.onend = () => { clearInterval(ttsResumeRef.current); setSpeakingId(null) }
        utterance.onerror = () => { clearInterval(ttsResumeRef.current); setSpeakingId(null) }
        setSpeakingId(msg.id)
        window.speechSynthesis.speak(utterance)
        // Chrome pauses speechSynthesis after ~15s; periodic resume prevents this
        ttsResumeRef.current = setInterval(() => {
            if (window.speechSynthesis.paused) window.speechSynthesis.resume()
        }, 10000)
    }

    const restrictedCount = restrictedChats.length

    return (
        <div
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
        >
            <style>{`
                @keyframes chatModalIn {
                    from { transform: translateY(-16px) scale(0.97); opacity: 0; }
                    to   { transform: translateY(0) scale(1); opacity: 1; }
                }
                .chat-session-item { cursor: pointer; border-radius: 10px; padding: 10px 12px; transition: background 0.15s; border: none; background: transparent; width: 100%; text-align: left; }
                .chat-session-item:hover { background: rgba(138,52,248,0.08); }
                .chat-session-item.active { background: rgba(138,52,248,0.13); }
                .chat-bubble-ai { background: #f0f4ff; color: #1a1a2e; border-radius: 4px 18px 18px 18px; max-width: 80%; padding: 10px 14px; line-height: 1.6; font-size: 14px; }
                .chat-bubble-kid { background: linear-gradient(135deg, #A44CD7, #F55145); color: #fff; border-radius: 18px 4px 18px 18px; max-width: 100%; padding: 10px 14px; line-height: 1.6; font-size: 14px; }
                .chat-scroll::-webkit-scrollbar { width: 4px; }
                .chat-scroll::-webkit-scrollbar-track { background: transparent; }
                .chat-scroll::-webkit-scrollbar-thumb { background: #d0d7f5; border-radius: 4px; }
                .sessions-scroll::-webkit-scrollbar { width: 4px; }
                .sessions-scroll::-webkit-scrollbar-track { background: transparent; }
                .sessions-scroll::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
                .chat-tab-btn { background: none; border: none; padding: 10px 18px; font-size: 13px; font-weight: 600; color: #999; cursor: pointer; border-bottom: 2.5px solid transparent; transition: color 0.15s, border-color 0.15s; }
                .chat-tab-btn:hover { color: #A44CD7; }
                .chat-tab-btn.active { color: #A44CD7; border-bottom-color: #A44CD7; }
                .restricted-scroll::-webkit-scrollbar { width: 4px; }
                .restricted-scroll::-webkit-scrollbar-track { background: transparent; }
                .restricted-scroll::-webkit-scrollbar-thumb { background: #f5c6c2; border-radius: 4px; }
                .tts-btn { background: none; border: none; padding: 4px 6px; cursor: pointer; border-radius: 8px; transition: background 0.15s, color 0.15s; color: #aaa; line-height: 1; }
                .tts-btn:hover { color: #A44CD7; background: rgba(164,76,215,0.10); }
                .tts-btn.speaking { color: #A44CD7; background: rgba(164,76,215,0.12); }
            `}</style>

            <div style={{ width: '100%', maxWidth: 1100, animation: 'chatModalIn 0.22s ease', display: 'flex', flexDirection: 'column', height: '88vh' }}>
                <div className="rounded-4 overflow-hidden d-flex flex-column" style={{ background: '#fff', boxShadow: '0 12px 48px rgba(0,0,0,0.22)', height: '100%' }}>

                    {/* Header */}
                    <div className="d-flex align-items-center gap-3 px-4 py-3 flex-shrink-0"
                        style={{ background: 'linear-gradient(135deg, #A44CD7, #F55145)', borderRadius: '16px 16px 0 0' }}>
                        <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{ width: 42, height: 42, background: 'rgba(255,255,255,0.25)', color: '#fff', fontWeight: 700, fontSize: 14 }}>
                            {getInitials(user.username)}
                        </div>
                        <div className="flex-grow-1">
                            <p className="fw-bold text-white mb-0" style={{ fontSize: 15 }}>{user.username}'s Chat History</p>
                            <p className="mb-0" style={{ fontSize: 12, color: 'rgba(255,255,255,0.80)' }}>
                                Age {user.age} &nbsp;·&nbsp; {conversations.length} conversation{conversations.length !== 1 ? 's' : ''}
                            </p>
                        </div>
                        <button type="button" onClick={onClose}
                            style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: '50%', width: 34, height: 34, color: '#fff', fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            ✕
                        </button>
                    </div>

                    {/* Tabs */}
                    <div className="d-flex flex-shrink-0 px-2" style={{ borderBottom: '1px solid #eee', background: '#fff' }}>
                        <button className={`chat-tab-btn ${activeTab === 'chats' ? 'active' : ''}`} onClick={() => setActiveTab('chats')}>
                            <i className="bi bi-chat-dots me-1"></i>Chats
                        </button>
                        <button className={`chat-tab-btn ${activeTab === 'restricted' ? 'active' : ''}`} onClick={() => setActiveTab('restricted')}>
                            <i className="bi bi-shield-exclamation me-1"></i>Restricted Chats
                            {restrictedCount > 0 && (
                                <span className="ms-1 badge rounded-pill" style={{ background: '#F55145', color: '#fff', fontSize: 11 }}>
                                    {restrictedCount}
                                </span>
                            )}
                        </button>
                    </div>

                    {/* Loading */}
                    {loadingChats && (
                        <div className="d-flex align-items-center justify-content-center flex-grow-1">
                            <div className="spinner-border" style={{ color: '#A44CD7' }} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* Chats panel */}
                    {!loadingChats && activeTab === 'chats' && (
                        <div className="d-flex flex-grow-1 overflow-hidden" style={{ position: 'relative' }}>

                            {/* Sidebar */}
                            <div className="sessions-scroll flex-shrink-0 d-flex flex-column"
                                style={{
                                    width: showSidebar ? 280 : 0,
                                    borderRight: showSidebar ? '1px solid #eee' : 'none',
                                    background: '#fafafa',
                                    overflowY: showSidebar ? 'auto' : 'hidden',
                                    transition: 'width 0.2s ease',
                                }}>
                                <div className="d-flex align-items-center justify-content-between px-3 pt-3 pb-2">
                                    <p className="mb-0 fw-semibold" style={{ fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.6px', whiteSpace: 'nowrap' }}>Conversations</p>
                                    <i className="bi bi-list" onClick={() => setShowSidebar(false)}
                                        style={{ cursor: 'pointer', color: '#888', flexShrink: 0, fontSize: '3rem' }}></i>
                                </div>
                                <div className="px-2 pb-3" style={{ minWidth: 260 }}>
                                    {conversations.map((conv) => (
                                        <button
                                            key={conv.id}
                                            className={`chat-session-item ${activeConversation?.id === conv.id ? 'active' : ''}`}
                                            onClick={() => fetchMessages(conv)}
                                        >
                                            <div className="d-flex align-items-start gap-2">
                                                <div className="flex-shrink-0 mt-1">
                                                    <i className="bi bi-chat-left-text" style={{ fontSize: 14, color: activeConversation?.id === conv.id ? '#A44CD7' : '#bbb' }}></i>
                                                </div>
                                                <div className="overflow-hidden">
                                                    <p className="mb-0 fw-semibold text-truncate"
                                                        style={{ fontSize: 13, color: activeConversation?.id === conv.id ? '#1a1a2e' : '#444' }}>
                                                        {conv.title}
                                                    </p>
                                                    <p className="mb-1" style={{ fontSize: 11, color: '#aaa' }}>{formatDate(conv.createdAt)}</p>
                                                    {conv.lastMessage?.content && (
                                                        <p className="mb-0 text-truncate" style={{ fontSize: 12, color: '#999' }}>
                                                            {conv.lastMessage.content}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            {activeConversation?.id === conv.id && (
                                                <div style={{ height: 2, background: 'linear-gradient(90deg, #A44CD7, #F55145)', borderRadius: 2, marginTop: 8 }} />
                                            )}
                                        </button>
                                    ))}
                                    {conversations.length === 0 && (
                                        <p className="text-center mt-4" style={{ fontSize: 13, color: '#aaa' }}>No conversations yet</p>
                                    )}
                                </div>
                            </div>

                            {/* Collapsed sidebar toggle */}
                            {!showSidebar && (
                                <div style={{
                                    position: 'absolute', left: 0, top: 0, width: 40,
                                    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
                                    paddingTop: 18, background: '#fafafa', borderRight: '1px solid #eee',
                                    zIndex: 10, cursor: 'pointer', height: '100%',
                                }} onClick={() => setShowSidebar(true)}>
                                    <i className="bi bi-list" style={{ fontSize: '3rem', color: '#888' }}></i>
                                </div>
                            )}

                            {/* Messages area */}
                            <div className="flex-grow-1 d-flex flex-column overflow-hidden" style={{ background: '#fafbff', marginLeft: showSidebar ? 0 : 40 }}>
                                {loadingMessages ? (
                                    <div className="d-flex align-items-center justify-content-center flex-grow-1">
                                        <div className="spinner-border" style={{ color: '#A44CD7' }} role="status" />
                                    </div>
                                ) : activeMessages ? (
                                    <>
                                        <div className="px-4 py-2 flex-shrink-0" style={{ borderBottom: '1px solid #eee', background: '#fff' }}>
                                            <p className="mb-0 fw-semibold" style={{ fontSize: 14, color: '#1a1a2e' }}>
                                                <i className="bi bi-chat-left-text me-2" style={{ color: '#A44CD7' }}></i>
                                                {activeMessages.title}
                                            </p>
                                            <p className="mb-0" style={{ fontSize: 12, color: '#aaa' }}>
                                                {formatDate(activeMessages.createdAt)} &nbsp;·&nbsp; {activeMessages.messages.length} messages
                                            </p>
                                        </div>

                                        <div className="chat-scroll flex-grow-1 px-4 py-4 d-flex flex-column gap-3" style={{ overflowY: 'auto' }}>
                                            {activeMessages.messages.map((msg) => (
                                                <div key={msg.id}
                                                    className={`chat-msg-row d-flex align-items-end gap-2 ${msg.role === 'kid' ? 'flex-row-reverse' : 'flex-row'}`}>
                                                    <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                                        style={{ width: msg.role === 'ai' ? 40 : 32, height: msg.role === 'ai' ? 40 : 32, fontSize: 13, fontWeight: 700, background: msg.role === 'ai' ? '' : '#A44CD7', color: msg.role === 'ai' ? '#A44CD7' : '#fff' }}>
                                                        {msg.role === 'ai' ? <img src={logo} alt="AI" /> : getInitials(user.username)}
                                                    </div>
                                                    <div className={`d-flex flex-column ${msg.role === 'kid' ? 'align-items-end' : 'align-items-start'}`}>
                                                        <div className={msg.role === 'ai' ? 'chat-bubble-ai' : 'chat-bubble-kid'}>
                                                            {msg.content}
                                                        </div>
                                                        <div className={`d-flex align-items-center gap-1 mt-1 ${msg.role === 'kid' ? 'flex-row-reverse' : ''}`}>
                                                            <span style={{ fontSize: 11, color: '#bbb' }}>{formatTime(msg.createdAt)}</span>
                                                            <button
                                                                className={`tts-btn ${speakingId === msg.id ? 'speaking' : ''}`}
                                                                onClick={() => speakMessage(msg)}
                                                                title={speakingId === msg.id ? 'Stop' : 'Read aloud'}
                                                            >
                                                                <i className={`bi ${speakingId === msg.id ? 'bi-volume-up-fill' : 'bi-volume-up'}`} style={{ fontSize: 18 }}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div ref={chatEndRef} />
                                        </div>

                                        <div className="d-flex align-items-center justify-content-center gap-2 py-2 flex-shrink-0"
                                            style={{ background: '#fff', borderTop: '1px solid #eee', fontSize: 12, color: '#bbb' }}>
                                            <i className="bi bi-lock-fill" style={{ fontSize: 11 }}></i>
                                            Read-only view
                                        </div>
                                    </>
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center flex-grow-1">
                                        <div className="text-center" style={{ color: '#ccc' }}>
                                            <i className="bi bi-chat-dots" style={{ fontSize: 48 }}></i>
                                            <p className="mt-3 mb-0">Select a conversation</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Restricted chats panel */}
                    {!loadingChats && activeTab === 'restricted' && (
                        <div className="restricted-scroll flex-grow-1 p-4" style={{ overflowY: 'auto', background: '#fafbff' }}>
                            {restrictedCount === 0 ? (
                                <div className="d-flex flex-column align-items-center justify-content-center" style={{ paddingTop: 80, color: '#aaa' }}>
                                    <i className="bi bi-shield-check" style={{ fontSize: 52, color: '#0CACC2', opacity: 0.5 }}></i>
                                    <p className="mt-3 mb-0 fw-semibold" style={{ fontSize: 15 }}>No restricted chats found</p>
                                    <p className="mb-0" style={{ fontSize: 13 }}>{user.username} has not used any restricted words.</p>
                                </div>
                            ) : (
                                <>
                                    <p className="mb-3 fw-semibold" style={{ fontSize: 13, color: '#999', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        {restrictedCount} restricted incident{restrictedCount !== 1 ? 's' : ''} detected
                                    </p>
                                    <div className="d-flex flex-column gap-3">
                                        {restrictedChats.map((incident) => (
                                            <div key={incident.id} style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #ffd6d3', padding: '14px 16px', boxShadow: '0 2px 10px rgba(245,81,69,0.06)' }}>
                                                <div className="d-flex align-items-start gap-3">
                                                    <div className="d-flex align-items-center justify-content-center flex-shrink-0"
                                                        style={{ width: 38, height: 38, borderRadius: '50%', background: '#fff0ee' }}>
                                                        <i className="bi bi-shield-exclamation" style={{ fontSize: 18, color: '#F55145' }}></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                                                            <p className="mb-0 fw-semibold" style={{ fontSize: 14, color: '#1a1a2e' }}>
                                                                <i className="bi bi-chat-left-text me-1" style={{ color: '#A44CD7', fontSize: 13 }}></i>
                                                                {incident.conversationTitle}
                                                            </p>
                                                            <span style={{ fontSize: 12, color: '#aaa' }}>
                                                                <i className="bi bi-calendar3 me-1"></i>{formatDate(incident.detectedAt)}
                                                                &nbsp;·&nbsp;
                                                                <i className="bi bi-clock me-1"></i>{formatTime(incident.detectedAt)}
                                                            </span>
                                                        </div>
                                                        <p className="mb-2 px-3 py-2 rounded-3" style={{ fontSize: 14, color: '#444', background: '#fff8f8', border: '1px solid #ffe0de', lineHeight: 1.6 }}>
                                                            "{highlightWords(incident.messageContent, incident.restrictedWords)}"
                                                        </p>
                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                            <span style={{ fontSize: 12, color: '#999' }}>Restricted words:</span>
                                                            {(Array.isArray(incident.restrictedWords) ? incident.restrictedWords : (() => { try { return JSON.parse(incident.restrictedWords) } catch { return [] } })()).map((word, i) => (
                                                                <span key={i} className="badge" style={{ background: '#fff0ee', color: '#d93025', border: '1px solid #ffc4be', fontSize: 12, fontWeight: 600 }}>
                                                                    {word}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}

export default AiChats
